import { AnyAction } from 'redux'
import { INITIAL_LANGUAGE } from '~/shared/constants/langConstants'
import { ScreenName } from '~/shared/services/eventLogger'
import { ICommonState } from '~/shared/store/types'

import {
  RESET_ERROR,
  SET_ANSWERS,
  SET_ANSWERS_FROM_BACKEND,
  SET_APP_CONFIG,
  SET_DYNAMIC_DISCOUNT,
  SET_ERROR,
  SET_IS_CONTEXT_ENABLED,
  SET_LANGUAGE,
  SET_SCREEN_NAME,
  SET_VARIANT,
  START_FETCHING,
  STOP_FETCHING,
} from './actionTypes'

const initState: ICommonState = {
  isFetching: false,
  actionList: [],
  error: null,
  currentVariant: null,
  appConfig: null,
  answers: null,
  language: INITIAL_LANGUAGE,
  screenName: ScreenName.ONBOARDING,
  dynamicDiscount: null,
  isInContextEnabled: false,
}

export function commonReducer(
  state: ICommonState = initState,
  { type, payload = null }: AnyAction,
): ICommonState {
  switch (type) {
    case START_FETCHING: {
      return {
        ...state,
        isFetching: true,
        actionList: state.actionList.concat(payload),
      }
    }
    case STOP_FETCHING: {
      return {
        ...state,
        isFetching: !!payload.length,
        actionList: payload,
      }
    }
    case SET_ERROR: {
      return {
        ...state,
        error: payload,
      }
    }
    case SET_IS_CONTEXT_ENABLED: {
      return {
        ...state,
        isInContextEnabled: payload,
      }
    }
    case SET_LANGUAGE: {
      return {
        ...state,
        language: payload,
      }
    }
    case RESET_ERROR: {
      return {
        ...state,
        error: null,
      }
    }
    case SET_VARIANT: {
      return {
        ...state,
        currentVariant: payload,
      }
    }
    case SET_APP_CONFIG: {
      return {
        ...state,
        appConfig: payload,
      }
    }
    case SET_ANSWERS: {
      return {
        ...state,
        answers: { ...state.answers, ...payload },
      }
    }
    case SET_ANSWERS_FROM_BACKEND: {
      return {
        ...state,
        answers: payload,
      }
    }
    case SET_SCREEN_NAME: {
      return {
        ...state,
        screenName: payload,
      }
    }
    case SET_DYNAMIC_DISCOUNT: {
      return {
        ...state,
        dynamicDiscount: payload,
      }
    }
    default:
      return state
  }
}
